module.exports = __webpack_public_path__ + "images/icons_v2/store-locator-baseline-filled-ece3f87d.svg";